[
  {
    "code": "MN-073",
    "name": "Arhangay"
  },
  {
    "code": "MN-071",
    "name": "Bayan-Ölgiy"
  },
  {
    "code": "MN-069",
    "name": "Bayanhongor"
  },
  {
    "code": "MN-067",
    "name": "Bulgan"
  },
  {
    "code": "MN-037",
    "name": "Darhan uul"
  },
  {
    "code": "MN-061",
    "name": "Dornod"
  },
  {
    "code": "MN-063",
    "name": "Dornogovi"
  },
  {
    "code": "MN-059",
    "name": "Dundgovi"
  },
  {
    "code": "MN-057",
    "name": "Dzavhan"
  },
  {
    "code": "MN-065",
    "name": "Govi-Altay"
  },
  {
    "code": "MN-064",
    "name": "Govi-Sümber"
  },
  {
    "code": "MN-039",
    "name": "Hentiy"
  },
  {
    "code": "MN-043",
    "name": "Hovd"
  },
  {
    "code": "MN-041",
    "name": "Hövsgöl"
  },
  {
    "code": "MN-035",
    "name": "Orhon"
  },
  {
    "code": "MN-049",
    "name": "Selenge"
  },
  {
    "code": "MN-051",
    "name": "Sühbaatar"
  },
  {
    "code": "MN-047",
    "name": "Töv"
  },
  {
    "code": "MN-1",
    "name": "Ulaanbaatar"
  },
  {
    "code": "MN-046",
    "name": "Uvs"
  },
  {
    "code": "MN-053",
    "name": "Ömnögovi"
  },
  {
    "code": "MN-055",
    "name": "Övörhangay"
  }
]